module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "stat-box",
    class: _vm.classNames
  }, [_c('div', {
    staticClass: "box-stat"
  }, [_c('div', {
    staticClass: "stat-box-value"
  }, [_vm._v(_vm._s(_vm.value))]), _c('div', {
    staticClass: "stat-box-title"
  }, [_vm._v(_vm._s(_vm.title)), (_vm.icon === 'outbound_clicks') ? _c('span', {
    staticClass: "tooltip-custom",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('icon', {
    staticClass: "question-icon",
    attrs: {
      "name": "question-circle",
      "scale": "1.25"
    }
  })], 1) : _vm._e(), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v(_vm._s(_vm.$t('terms.stats.outbound.tooltip')))])])]), (_vm.details) ? _c('div', {
    staticClass: "box-details"
  }, [(_vm.showDetails === false) ? _c('div', {
    staticClass: "view-details",
    on: {
      "click": _vm.toggleShowDetails
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.campaign.stats-see-details')))]), _c('icon', {
    attrs: {
      "name": "chevron-down",
      "small": true
    }
  })], 1) : _c('div', {
    staticClass: "close-details",
    on: {
      "click": _vm.toggleShowDetails
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pos.campaign.stats-close-details')))]), _c('icon', {
    attrs: {
      "name": "chevron-up"
    }
  })], 1), (_vm.showDetails) ? _c('div', {
    staticClass: "details"
  }, _vm._l((_vm.details), function(detail) {
    return _c('div', {
      staticClass: "detail"
    }, [_c('div', {
      staticClass: "detail-number"
    }, [_vm._v(_vm._s(_vm.$t('fn.number', {
      value: detail.value
    })))]), _c('div', {
      staticClass: "detail-title"
    }, [_vm._v(_vm._s(_vm.$t("fn.complex.stats", {
      name: detail.name
    })))])])
  })) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21bca3ff"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-statistics/stat-box/StatBox.vue
// module id = 2020
// module chunks = 1